/* __next_internal_client_entry_do_not_use__ ExpandableToFullHeight auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import isChromatic from "chromatic/isChromatic";
import * as React from "react";
import styled from "styled-components";
var MAX_COLLAPSED_HEIGHT = 360;
export var ExpandableToFullHeight = function(param) {
    var _param_initiallyExpanded = param.initiallyExpanded, initiallyExpanded = _param_initiallyExpanded === void 0 ? false : _param_initiallyExpanded, _param_maximumHeight = param.maximumHeight, maximumHeight = _param_maximumHeight === void 0 ? MAX_COLLAPSED_HEIGHT : _param_maximumHeight, children = param.children;
    var _wrapperRef_current;
    var _React_useState = _sliced_to_array(React.useState(initiallyExpanded), 2), isExpanded = _React_useState[0], setIsExpanded = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), showButton = _React_useState1[0], setIsShowButton = _React_useState1[1];
    var wrapperRef = React.useRef(null);
    React.useEffect(function() {
        var showButton = !!(wrapperRef.current && wrapperRef.current.scrollHeight > maximumHeight);
        setIsShowButton(showButton);
        if (!showButton) {
            setIsExpanded(true);
        }
    }, [
        maximumHeight,
        (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.scrollHeight
    ]);
    var handleClick = function() {
        setIsExpanded(!isExpanded);
    };
    var shouldAlwaysExpand = isChromatic();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Wrapper, {
                ref: wrapperRef,
                style: {
                    maxHeight: isExpanded || shouldAlwaysExpand ? "unset" : "".concat(maximumHeight, "px"),
                    overflowY: isExpanded || shouldAlwaysExpand ? "visible" : "auto"
                },
                children: children
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            showButton && !shouldAlwaysExpand ? /*#__PURE__*/ _jsx(ButtonWrapper, {
                role: "button",
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(StyledChevron, {
                    direction: isExpanded ? "up" : "down"
                })
            }) : /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            })
        ]
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-e21adce5-0"
})([
    "-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
]);
var ButtonWrapper = styled.div.withConfig({
    componentId: "sc-e21adce5-1"
})([
    "width:100%;display:flex;padding:",
    ";cursor:pointer;"
], getSpacing("1x"));
var StyledChevron = styled(Chevron).withConfig({
    componentId: "sc-e21adce5-2"
})([
    "margin:auto;"
]);
